module.exports = __webpack_public_path__ + "static/scale-model-of-wisconsin-governor's-mansion-in-madison-wisconsin-d552662e5180676f893471829f4b6ac4.png";